import { createSelector } from 'reselect';

import { getApplicationLocale } from '@epi-store/application/application.selectors';
import { addLocale } from '@epi-helpers/UrlHelpers';

export const getLastSavedPath = (state): string =>
  state.navigation.locationHistory[0];

export const getNavigationHistory = (state): string[] =>
  state.navigation.locationHistory;

export const generateUrlWithLocale = (url: string) =>
  createSelector(getApplicationLocale, locale => addLocale(locale, url));
